import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { UnderconstructionComponent } from '@pg-app/auth/components/underconstruction/underconstruction.component';
import { BaseNavComponent } from '@pg-app/core/components/base-nav/base-nav.component';
import { ClientNavComponent } from '@pg-app/core/components/client-nav/client-nav.component';
import { AppComponent } from '@pg-app/core/containers/app.component';
import { ClientLayoutComponent } from '@pg-app/core/containers/client-layout/client-layout.component';
import { LayoutComponent } from '@pg-app/core/containers/layout/layout.component';
import { NotFoundComponent } from '@pg-app/core/containers/not-found/not-found.component';
import { CustomHttpInterceptor } from '@pg-app/core/interceptors/custom-http.interceptor';
import { TokenInterceptor } from '@pg-app/core/interceptors/token.interceptor';
import { GlobalErrorHandler } from '@pg-app/core/services/global-error-handler';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { CommonDialogModule } from '@pg-app/common/common-dialog-module.module';
import { CheckAccountModule } from '@pg-app/client/client-dashboard/dialogs/check-account/check-account.module';
import { CheckVersionModule } from '@pg-app/shared/components/check-version/check-version.module';
import { MatSelectHybridModule } from '@nttp/mat-select-hybrid/mat-select-hybrid.module';

@NgModule({
  declarations: [
    AppComponent,
    BaseNavComponent,
    LayoutComponent,
    NotFoundComponent,
    ClientNavComponent,
    ClientLayoutComponent,
    UnderconstructionComponent
  ],
  imports: [
    CommonModule,
    NgHttpLoaderModule.forRoot(),
    RouterModule,
    CoreUiModule,
    CoreMaterialModule,
    TranslateModule,
    CommonDialogModule,
    CheckAccountModule,
    CheckVersionModule,
    MatSelectHybridModule
  ],
  exports: [AppComponent, BaseNavComponent, TranslateModule],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    }
  ]
})
export class CoreModule { }
